import { dataBeforeSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBeforeSquareSolid = /*#__PURE__*/createIcon(dataBeforeSquareSolid)
export default IconBeforeSquareSolid
